module.exports = __webpack_public_path__ + "img/4.3c289741.jpg";